export default __webpack_public_path__ + "static/raven-4-a-5a8c0de33c132d0b738b6334e7a1cf8a.webp";